import React, { useEffect } from "react";
import "./Modal.scss";

const Modal = ({
  show,
  onClose,
  title,
  children,
  footer,
  width,
  outsideClickClose = true,
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (show) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      className="modal-overlay-bkfc"
      onClick={() => {
        if (outsideClickClose) onClose();
      }}
    >
      <div
        className="modal-content-bkfc"
        onClick={(e) => e.stopPropagation()}
        style={{ width: width ?? "auto" }}
      >
        {title && (
          <div className="modal-header-bkfc">
            <div className="modal-header-title-bkfc">{title}</div>
            <button className="close-button-bkfc" onClick={onClose}>
              &times;
            </button>
          </div>
        )}
        <div className="modal-body-bkfc">{children}</div>
        {footer && <div className="modal-footer-bkfc">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
